module.exports = __webpack_public_path__ + "static/media/MIOTA.3adde8e2.svg";